<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-col lg="11" sm="8" xl="7">
        <v-card class="elevation-4">
          <v-row>
            <v-col lg="7" class="info d-none d-md-flex align-center justify-center">
              <div class="d-none d-sm-block">
                <div class="d-flex align-center pa-10">
                  <div>
                    <h3
                      class="display-1 white--text font-weight-heavy"
                    ><strong>Move It NQ:</strong></h3>
                    <h3
                      class="display-1 white--text font-weight-heavy"
                    >Programs Dashboard</h3>
                    <h6
                      class="subtitle-1 mt-4 white--text font-weight-bold">Experiencing login issues or have tech questions?</h6><br>
                    <v-btn href="https://moveitnq.com.au/support/" target="_blank" class="black--text my-2 mr-4" medium color="white">VISIT TECH SUPPORT</v-btn><br>

                    <v-btn
                    color="black"
                    class="white--text my-2 mr-4"
                    @click='$router.push({path: "/authentication/submission"})'
                  >Submission Portal</v-btn><br>
                    <v-btn
                    color="black"
                    class="white--text my-2 mr-4"
                    @click='$router.push({path: "/authentication/wexer"})'
                  >OnDemand Sign Up</v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col lg="5">
              <div class="pa-7 pa-sm-12">
                <img src="@/assets/images/logo-icon.png" />
                <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2">Administrator Portal</h2>

                <v-form ref="form" action="/dashboards/classic">
                  <v-text-field
                    v-model="email"
                    label="Username"
                    class="mt-4"
                    required
                    outlined
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    label="Password"
                    :type="'password'"
                    required
                    outlined
                  ></v-text-field>
                  <v-btn
                    color="black"
                    block
                    class="white--text mr-4"
                    submit
                    @click="submit"
                  >Sign In</v-btn>
                  <div class="error" v-if="error">{{error.message}}</div>
                </v-form>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";

export default {
  data() {
    return {
      email: "",
      password: "",
      error: ""
    };
  },
  mounted() {
    this.$root.loading = false;
  },
  methods: {
    submit() {
      // var email = this.email
      // var a1 = this.email.search("minq.com.au");
      // var a2 = this.email.search("gmail.com");
      // var a3 = this.email.search("nqsports.com.au");
      // var a4 = this.email.search("moveitnq.com.au");
      // if(a4 < 0 && a3 < 0 && a1 < 0 && a2 < 0)
      // {
        // console.log('not found ',email)
        // localStorage.setItem('lgaUser',email)
        // email = email+"@minq.com.au";
         firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(data => {
          console.log('login successfull', data);
          
          location.reload()
        })
        .catch(error => {
          this.error = error;
        });
      // }else{
        // console.log('found ',email)
        // let lga = email.search("@minq.com.au");
        // if(lga > -1)
        // {
          // var m = email.replace("@minq.com.au",'')
          // localStorage.setItem('lgaUser',m)
        // }else{
          //JY THEE
        // }
        // console.log(this.email, this.password)
        //  firebase
        // .auth()
        // .signInWithEmailAndPassword(this.email, this.password)
        // .then(data => {
          // console.log(data);
          // location.reload()
        // })
        // .catch(error => {
          // this.error = error;
        // });
      // }
     
    }
  }
};
</script>
